export default [
  {
    path: "/user/locations",
    name: "UserLocations",
    component: () => import("@/views/Ondemand/Locations.vue"),
  },
];
